import { Icon, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { BsFillInfoCircleFill } from 'react-icons/all';

interface FileStatusProps {
  relatorio?: number;
  tipo?: number;
}
export const FileStatus: React.VFC<FileStatusProps> = ({ relatorio, tipo }) => {
  const getMsgVencimento = () => {
    if (relatorio === 0) {
      return 'O arquivo gerado será disponibilizado para download no formato .CSV';
    }
    return 'O arquivo .CSV gerado será compactado para download no formato ZIP';
  };

  const getStatusIcon = () => {
    switch (tipo) {
      case 0:
        return (
          <Tooltip
            hasArrow
            label={getMsgVencimento()}
            bg="black"
            shouldWrapChildren
          >
            <Icon as={BsFillInfoCircleFill} />
          </Tooltip>
        );
      case 1:
        return (
          <Tooltip
            hasArrow
            label="O arquivo gerado será disponibilizado para download no formato .XLSX"
            bg="black"
            shouldWrapChildren
          >
            <Icon as={BsFillInfoCircleFill} />
          </Tooltip>
        );
      default:
        return (
          <Tooltip
            hasArrow
            label="O arquivo .CSV gerado será compactado para download no formato ZIP"
            bg="black"
            shouldWrapChildren
          >
            <Icon as={BsFillInfoCircleFill} />
          </Tooltip>
        );
    }
  };

  return getStatusIcon();
};
